import { createInput, createSelect, MountTarget, newDialog, readConfig } from './utils/elements';

export const SPLITSBOOM_EDIT_SELECTOR = '.cds-lrn-splitsboom';

interface SplitsboomConfig {
  amount: number;
  withBorder: boolean;
}

export function splitsboomDialog(
  insertHtml: (html: string) => void,
  mountTarget?: MountTarget,
  existingEl?: HTMLElement
) {
  const dialog = newDialog('Splitsboom maken', () => insertHtml(''), mountTarget);
  const selectAmount = createSelect('amount', 'Splitsen in', [
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
    { label: '9', value: '9' },
    { label: '10', value: '10' },
  ]);

  const withBorderCheck = createInput('withBorder', 'Met rand', 'checkbox');

  if (existingEl) {
    const cfg = readConfig<SplitsboomConfig>(existingEl, { amount: 2, withBorder: true });
    if (cfg.amount) selectAmount.setValue(String(cfg.amount));
    withBorderCheck.setChecked(!!cfg.withBorder);
  }

  dialog.querySelector('#cds-dialog-content').append(selectAmount.field, withBorderCheck.field);

  dialog.addEventListener('onSubmit', () => {
    const config: SplitsboomConfig = { amount: +selectAmount.value(), withBorder: withBorderCheck.checked() };
    insertHtml(makeSplitsboom(config));
  });
}


function makeSplitsboom(config: SplitsboomConfig) {
  const amount = config.amount;
  const withBorder = config.withBorder;

  const container = document.createElement('div');
  container.classList.add('cds-lrn-splitsboom');
  container.setAttribute('data-cb-config', JSON.stringify(config));

  container.classList.add('grid', 'col-gap-3xs', 'w-fit', 'm-i-auto');
  container.style.gridTemplateColumns = `repeat(${amount}, 1fr)`;
  container.style.gridTemplateRows = 'auto 24px auto';

  const topRow = document.createElement('div');
  topRow.classList.add('flex', 'justify-center', 'items-center', 'col-span-full');

  const topText = document.createElement('div');
  topText.append('placeholder');
  topText.classList.add('p-i-xs', 'p-b-2xs', 'corner-xs', 'w-fit', 'm-i-auto');
  if (withBorder) {
    topText.classList.add('border');
  }
  topRow.append(topText);

  const middleRow = document.createElement('div');
  middleRow.classList.add('relative', 'p-0', 'text-center', 'col-span-full');

  const svg = document.createElement('svg');
  svg.setAttribute('width', '100%');
  svg.setAttribute('height', '100%');
  svg.setAttribute('preserveAspectRatio', 'none');
  svg.classList.add('absolute', 'inset-0');

  middleRow.append(svg);

  container.append(topRow, middleRow);

  const start = 100 / (amount * 2);
  const step = 100 / amount;

  for (let i = 0; i < amount; i++) {
    const placeholder = document.createElement('div');
    placeholder.classList.add(
      'p-i-xs',
      'p-b-2xs',
      'corner-xs',
      'w-fit',
      'm-i-auto',
      'white-space-nowrap',
      'text-center'
    );
    if (withBorder) {
      placeholder.classList.add('border');
    }
    placeholder.append('X');
    container.append(placeholder);

    const line = document.createElement('line');
    line.setAttribute('x1', '50%');
    line.setAttribute('x2', start + step * i + '%');
    line.setAttribute('y1', '0%');
    line.setAttribute('y2', '100%');
    line.classList.add('stroke-stroke');
    line.style.strokeWidth = '2px';
    svg.append(line);
  }

  return container.outerHTML;
}
